// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 19351 ? "a5ce6a92" : chunkId) + "." + {"19351":"c1f7de0082641d15","37525":"43cdc0cce8190a1a","40300":"a043eed9d3b1e90f","53348":"7d3c239a60d16204"}[chunkId] + ".js";
};